/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import OGBox from "assets/theme/components/OGBox";
import OGTypography from "assets/theme/components/OGTypography";
import brandLogo from "assets/images/others/oogoal.png";

function Breadcrumbs({ title, route, darkMode }) {
  const routes = route.slice(0, -1);

  return (
    <OGBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: () => (darkMode ? "white" : "dark"),
          },
        }}
      >
        <Link to="/">
          <OGTypography
            component="span"
            variant="body2"
            color={darkMode ? "white" : "dark"}
            opacity={1}
            sx={{ lineHeight: 0 }}
          >
            <OGBox component="img" src={brandLogo} alt="ooGoal" width="2rem" />
          </OGTypography>
        </Link>
      </MuiBreadcrumbs>
    </OGBox>
  );
}

Breadcrumbs.defaultProps = {
  darkMode: false,
};

Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  darkMode: PropTypes.bool,
};

export default Breadcrumbs;
